import { template as template_3bc644779c104aa792a67fa74168f5b5 } from "@ember/template-compiler";
import { service } from '@ember/service';
import ClassOnScroll from 'client-portal/modifiers/class-on-scroll';
import Component from '@glimmer/component';
import RequestClinicianSearchMobileClinicianSearchHeader from './mobile-clinician-search-header';
import RequestSignInTeaser from '../sign-in-teaser';
import SignInLinkTo from 'client-portal/components/sign-in/link-to';
import styles from './header.module.scss';
import t from 'ember-intl/helpers/t';
export default class RequestClinicianSearchHeader extends Component {
    @service
    clinicianSearch;
    @service
    session;
    styles = styles;
    get variant() {
        return this.args.variant || 'site';
    }
    get signedIn() {
        return this.session.isExistingClient;
    }
    get isWidget() {
        return this.variant === 'widget';
    }
    get showSiteDesktopSignIn() {
        let { signedIn, isWidget } = this;
        return !signedIn && !isWidget;
    }
    onCloseMobile = this.clinicianSearch.mobile.hideHeader;
    static{
        template_3bc644779c104aa792a67fa74168f5b5(`
    <div
      class="{{styles.component}}
        clinician-search-header clinician-search-header-{{this.variant}}
        {{if this.signedIn 'signed-in'}}"
      data-test-clinician-search-header
      {{ClassOnScroll scrollTarget=68 offset=24}}
      ...attributes
    >
      {{#if this.isWidget}}
        {{#unless this.signedIn}}
          <div class="widget-sign-in-card" data-test-existing-sign-in>
            <RequestSignInTeaser
              @copySet="widget"
              @linkVariant="external"
              @therapyfinderEmbed={{@therapyfinderEmbed}}
              @visibilityBreakpoint="lg"
            />
          </div>
        {{/unless}}
      {{else if this.clinicianSearch.mobile.isHeaderVisible}}
        <RequestClinicianSearchMobileClinicianSearchHeader @onClose={{this.onCloseMobile}}>
          {{#unless this.signedIn}}
            <RequestSignInTeaser @copySet="site" @linkVariant="in-app" @visibilityBreakpoint="md" />
          {{/unless}}
        </RequestClinicianSearchMobileClinicianSearchHeader>
      {{/if}}

      {{#if this.showSiteDesktopSignIn}}
        <div class="desktop-sign-in-card" data-test-existing-sign-in>
          <span class="existing-sign-in-text">
            {{t "signIn.clinicianSearchExistingSignInLead"}}
          </span>
          <SignInLinkTo
            @classNames="existing-sign-in-link"
            @title={{t "signIn.clinicianSearchSignInLink"}}
          />
        </div>
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
